export { default } from './init-shimmer';
